import { jsx } from "react/jsx-runtime";
import { Path, SVG } from "@wordpress/primitives";
var chevron_down_small_default = /* @__PURE__ */ jsx(SVG, { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ jsx(Path, { d: "m15.99 10.889-3.988 3.418-3.988-3.418.976-1.14 3.012 2.582 3.012-2.581.976 1.139Z" }) });
export {
  chevron_down_small_default as default
};
//# sourceMappingURL=chevron-down-small.js.map
